'use client'

import type { ITravelPointQuote } from '@repo/sdk'
import type { UseFieldArrayInsert, UseFieldArrayRemove } from 'react-hook-form'

import { createContext, PropsWithChildren, useContext } from 'react'

interface Context {
  drops: ITravelPointQuote[]
  insertDrop: UseFieldArrayInsert<{ drops: Partial<ITravelPointQuote>[] }, 'drops'>
  removeDrop: UseFieldArrayRemove
}

export const DropsContext = createContext<Context>({} as Context)

type Props = Context

export const DropContextProvider = ({
  children,
  drops,
  insertDrop,
  removeDrop,
}: PropsWithChildren<Props>) => {
  return (
    <DropsContext.Provider value={{ drops, insertDrop, removeDrop }}>
      {children}
    </DropsContext.Provider>
  )
}

export const useDropsContext = () => {
  const context = useContext(DropsContext)

  if (!context) {
    throw new Error('useDropsContext must be used within a DropsContextProvider')
  }

  return context
}
